import { render, staticRenderFns } from "./login-container-v2.vue?vue&type=template&id=16538106&"
import script from "./login-container-v2.vue?vue&type=script&lang=ts&"
export * from "./login-container-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports